import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/password-reset.php';

const service_path_public = '/password-reset-public.php';


export async function sendResetPasswordToken() {

    try {
        const response = await api.get(service_path);

        const { data } = response;

        if (data) {
            return data;
        } else {
            globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
        };

    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
    };
};

export async function sendResetPasswordTokenPublic(email) {

    try {
        const response = await api.get(`${service_path_public}?email=${email}`);

        const { data } = response;

        if (data) {
            return data;
        } else {
            globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
        };

    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
    };
}

export async function validateResetPasswordToken(verification_token) {

    try {
        const response = await api.get(`${service_path}?verification_token=${encodeURIComponent(verification_token)}`);

        const { data } = response;

        if (data) {
            return data;
        } else {
            globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
        };

    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
    };
};

export async function validateResetPasswordTokenPublic(verification_token, email) {
    try {
        const response = await api.get(`${service_path_public}?verification_token=${encodeURIComponent(verification_token)}&email=${email}`);

        const { data } = response;

        if (data) {
            return data;
        } else {
            globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
        };

    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao carregar o conteúdo desta página!");
    };
};

export async function updatePassword(newPassword) {

    const payload = {
        password: newPassword,
    };

    try {
        const response = await api.patch(service_path, payload);

        const { data } = response;

        if (data) {
            return data;
        } else {
            globalToast.error("Houve um erro ao atualizar a senha!");
        }
    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao atualizar a senha!");
    }
};

export async function updatePasswordPublic(verification_token, newPassword) {

    const payload = {
        verification_token: verification_token,
        password: newPassword,
    };

    try {
        const response = await api.patch(service_path_public, payload);

        const { data } = response;

        if (data) {
            return data;
        } else {
            globalToast.error("Houve um erro ao atualizar a senha!");
        }
    } catch (error) {
        console.log(error);
        globalToast.error("Houve um erro ao atualizar a senha!");
    }
};
